// Justificativas de alteração de quantidade usadas nos modais de Criar Pedido
// (compra e compra programada). Lista única para não divergir entre as telas.
export const JUSTIFICATIVA_PERSONALIZADA = 'Personalizado'

export const PREDEFINED_JUSTIFICATIONS: string[] = [
  'Ajuste de estoque',
  'Formação de carga',
  'Demanda sazonal',
  'Promoção especial',
  'Correção de forecast',
  'Problema no fornecedor',
  'Alteração de mix',
  'Otimização de compra',
  'Redução de excesso',
  'Urgência operacional',
  'Melhoria de giro',
  'Reposição por avaria/perda',
  JUSTIFICATIVA_PERSONALIZADA
]

// SKU cuja quantidade desejada difere da recomendada e precisa de justificativa
export interface AlteredSku {
  id: number
  loja: { id: number; descricao?: string }
  produto: { id: number; descricao?: string }
  idEmpresa?: number
  // Quantidade de referência (recomendação). Voltando a ela o SKU deixa de ser alterado.
  quantidadeOriginal: number
  novaQuantidade: number
  justificativa: string
  observacao: string
  acimaToleranciaPermitida?: boolean
  valor?: number
  usuarioAprovadorEmail?: string
}

// Insere/atualiza o SKU alterado na lista (para uso dentro do updater do immer).
// Quando a nova quantidade volta à original o SKU é removido.
// Preserva justificativa, observação e aprovador já informados.
export const upsertAlteredSku = (
  draft: AlteredSku[],
  sku: Omit<AlteredSku, 'justificativa' | 'observacao'>
): void => {
  const index = draft.findIndex(item => item.id === sku.id)
  const quantidadeOriginal = Number(sku.quantidadeOriginal) || 0
  const novaQuantidade = Number(sku.novaQuantidade) || 0

  if (novaQuantidade === quantidadeOriginal) {
    if (index !== -1) draft.splice(index, 1)
    return
  }

  if (index !== -1) {
    Object.assign(draft[index], {
      ...sku,
      quantidadeOriginal,
      novaQuantidade,
      usuarioAprovadorEmail:
        sku.usuarioAprovadorEmail ?? draft[index].usuarioAprovadorEmail
    })
    return
  }

  draft.push({
    ...sku,
    quantidadeOriginal,
    novaQuantidade,
    justificativa: '',
    observacao: ''
  })
}

export const filterAlteredSkus = (
  skus: AlteredSku[],
  searchTerm: string
): AlteredSku[] => {
  const term = searchTerm.trim().toLowerCase()
  if (!term) return skus

  return skus.filter(
    sku =>
      sku.produto?.descricao?.toLowerCase().includes(term) ||
      String(sku.produto?.id ?? '').includes(term) ||
      String(sku.loja?.id ?? '').includes(term) ||
      sku.loja?.descricao?.toLowerCase().includes(term)
  )
}

// Percentual de alteração da nova quantidade sobre a original
export const getPercentualAlteracao = (sku: AlteredSku): number => {
  if (!sku.quantidadeOriginal) return sku.novaQuantidade > 0 ? 100 : 0
  return (
    ((sku.novaQuantidade - sku.quantidadeOriginal) / sku.quantidadeOriginal) *
    100
  )
}
